<template>
  <div class="ApiEditForm ApiEditFormUni">
    <el-dialog
      class="customDialog"
      title="编辑数据源"
      :visible.sync="isShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close"
    >
      <!-- 数据源键值 -->
      <div class="keyName">
        <div class="api-container" v-if="alias.length > 0">
          <div class="item" v-for="item in alias" :key="item.key">
            <el-tooltip
              :content="item.key"
              placement="top-end"
              effect="light"
              :open-delay="1000"
              ><span>{{ item.key }}：</span></el-tooltip
            >
            <el-input
              maxlength="20"
              show-word-limit
              v-model.trim="item.name"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <Empty v-else></Empty>
      </div>
      <!-- 操作按钮 -->
      <div class="handlerBtn">
        <el-button type="default" @click="close">取消</el-button>
        <el-button type="primary" @click="submit()">确认</el-button>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { editApiForm } from '@/api/dataManagement'
export default {
  name: 'apiEditForm',
  props: {
    apiEditFormData: {
      type: Object,
      default: () => ({ name: '' })
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data () {
    return {
      alias: [],
      ruleForm: {
        dataSourceType: 'API接口',
        dataSourceName: '',
        dataSource: ''
      }
    }
  },
  computed: {
    isShow: {
      get: function () {
        return this.show
      },
      set: function (v) {
        // 点击关闭按钮更新父组件传过来的参数为false
        this.$emit('update:show', v)
      }
    }
  },
  watch: {
    apiEditFormData: {
      handler () {
        this.alias = this.apiEditFormData.apiConfig.config.alias.map((v) => v)
      },
      // immediate: true,
      deep: true
    }
  },
  mounted () {},
  methods: {
    // 编辑数据源键值别名
    submit () {
      this.alias.forEach((v) => {
        v.name = v.name.trim()
      })
      const params = {
        httpApiConfig: {
          alias: this.alias,
          id: this.apiEditFormData.apiConfig.id
        },
        id: this.apiEditFormData.id,
        name: this.apiEditFormData.name
      }
      editApiForm(params)
        .then((res) => {
          if (res.code === 200) {
            this.$emit('refreshTable')
            this.$message.success('编辑成功!')
            this.isShow = false
          }
        })
        .catch(() => {
          this.isShow = false
        })
    },
    close () {
      document.querySelectorAll('.apiTooltip').forEach((v) => {
        v.style.visibility = 'hidden'
      })
      this.$emit('refreshTable')
      this.isShow = false
    }
  }
}
</script>

<style lang="scss">
.ApiEditForm.ApiEditFormUni {
  .customDialog {
    .el-dialog {
      width: 890px;
      .legend::before {
        content: "";
        width: 4px;
        height: 12px;
        background: #00a4f0;
        border-radius: 2px;
        margin-right: 8px;
      }
      .legend {
        display: flex;
        align-items: center;
        .tip {
          color: #999999;
        }
      }
      .el-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 26px;
        .el-input__inner {
          width: 260px;
          height: 32px;
        }
      }
      .info {
        border-bottom: 2px solid rgb(78, 78, 78);
        margin-bottom: 20px;
      }
    }
    .handlerBtn {
      text-align: right;
      button {
        width: 80px;
      }
      button + button {
        margin-left: 20px;
      }
    }
    .keyName {
      margin-bottom: 10px;
      .api-container {
        min-height: 108px !important;
        max-height: 400px !important;
        overflow: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 0 25px 0 23px;
        > .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .el-tooltip {
            width: 102px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            text-align: right;
            margin-right: 4px;
            color: #999;
          }
          .el-input {
            width: 260px;
          }
        }
        > .item {
          margin-top: 23px;
        }
        > .item:first-child,
        .item:nth-child(2) {
          margin-top: 0;
        }
      }
    }
  }
  .el-dialog__footer {
    display: none;
  }
  .el-dialog__body {
    text-align: left;
    border-radius: 6px;
    .uolpad {
      margin-bottom: 21px;
      position: relative;
      .fileHandler {
        padding-left: 30px;
        .submitBtn {
          width: 164px;
          height: 32px;
          padding: 0 15px;
          background: rgba(0, 164, 240, 0.1);
          border: 1px dashed #00a4f0;
          border-radius: 6px;
          cursor: pointer;
          color: #00a4f0;
          display: flex;
          align-items: center;
          justify-content: space-around;
          img {
            width: 21px;
          }
        }
      }
      .el-upload-list {
        margin: 0 30px 0 130px;
      }
      .el-upload-list__item {
        background: rgba(0, 0, 0, 0.3);
        .el-upload-list__item-name {
          color: #fff;
        }
      }
      .el-upload-list__item:hover {
        background: rgba(0, 0, 0, 0.4);
      }
    }
    .downLoad {
      font-size: 14px;
      cursor: pointer;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #00a4f0;
      position: absolute;
      right: 32px;
      top: 23px;
      a {
        text-decoration: none !important;
        color: #00a4f0;
      }
    }
    p {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 22px;
  }
}
</style>
